import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { Eyebrow, PillButton, SurfaceCard } from "../components/ui";
import { paths } from "./paths";

export default function ErrorPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: `min(100%, 560px)`,
        mx: "auto",
        px: { mobile: 2.5, tablet: 3 },
        py: { mobile: 6, laptop: 10 },
      }}
    >
      <Eyebrow>Page not found</Eyebrow>
      <Typography variant="h2" sx={{ mb: 3 }}>
        This page does not exist.
      </Typography>

      <SurfaceCard>
        <Typography variant="body1" sx={{ mb: 3 }}>
          The link may be out of date. Installation instructions now live on the
          Artome support portal, and the installer portal covers product
          registration.
        </Typography>

        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
          <PillButton tone="amber" withArrow onClick={() => navigate(paths.home)}>
            Go to the portal home
          </PillButton>
          <PillButton tone="outline" onClick={() => navigate(paths.guides)}>
            Installation guides
          </PillButton>
        </Box>
      </SurfaceCard>
    </Box>
  );
}
